<template>
  <div
    id="hep-sub-card"
    class="bg-black rounded lg:w-full p-6 mt-4 max-w-screen-lg mx-auto">
    <div class="grid grid-cols-12 gap-2 text-white items-center">
      <div class="col-span-12 lg:col-span-3 text-left flex justify-center lg:justify-start items-center">
        <img
          src="//summitproedu.imgix.net/redesign-assets/hep/hep_logo_1.svg"
          alt="HEP Logo"
          class="h-14 mr-3"
        />
        <div>
          <h3 class="text-white leading-none">
            Summit HEP
          </h3>
          <p class="font-bold text-accent-light text-xs">
            Powered by Wibbi
          </p>
        </div>
      </div>
      <div class="col-span-12 lg:col-span-7 lg:text-left">
        <p class="text-xs lg:text-base text-white font-bold px-4 md:p-0">
          Give patients unlimited access to 20,000+ Home Exercise Program videos.
        </p>
        <p class="text-xs lg:text-base  text-white font-bold px-4 md:p-0">
          Add to any subscription for <span class="text-accent-light">ONLY $9.99/mo.</span> Cancel anytime.
        </p>
      </div>
      <div class="col-span-12 lg:col-span-2 flex justify-center lg:justify-end">
        <t-button
          variant="ctaPrimary"
          @click="$router.push('/subscription/hep')"
        >
          Learn More <t-icon
            name="chevron-right"
            class="ml-2"
          />
        </t-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HepHorizontal',
};
</script>
